import { render, staticRenderFns } from "./InternalForm.vue?vue&type=template&id=50f5c858&scoped=true"
import script from "./InternalForm.vue?vue&type=script&lang=js"
export * from "./InternalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f5c858",
  null
  
)

export default component.exports